import type { FortuneIconProps } from '@/app_components/icons/constants';

export const ButtonDown = ({ className, ...props }: FortuneIconProps) => {
  return (
    <svg
      className={className}
      fill='none'
      height='8'
      viewBox='0 0 12 8'
      width='12'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Down Arrow Button Icon</title>
      <path
        d='M1 1.5L6 6.5L11 1.5'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.25'
      />
    </svg>
  );
};
